import script from "./CreateRelationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRelationButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CreateRelationButton.vue"]])

export default __exports__